import { toast } from "react-toastify";
import { putBlock } from "../service/putBlock";
import convertAmountInCents from "../utils/amountInCents";
import { TIME_RESULT } from "../utils/notifications/time";
import { toastUpdate } from "../utils/notifications/toast";
import { IProduct } from "../views/ecommerce/products/interfaces";

export const updateDetails = async (
    selectedProduct: IProduct,
    values: any,
    toastId?: string
): Promise<{
    isError: boolean,
    block: any
}> => {
    let amount = null

    if(values.amount !== "") {
        amount = convertAmountInCents(values.amount).toString()
    }
    
    const { block, isError } = await putBlock("/branch/products/details", {
        details: values.details,
        amount: amount,
        active: values.status,
        id: selectedProduct.id,
        productId: selectedProduct.id
    });

    if(toastId) {

        if(isError) {
            toastUpdate(
                toastId,
                "error",
                TIME_RESULT,
                "Houve um problema ao editar a variação, entre em contato com o suporte."
            )
        }
    
        else {
            toastUpdate(
                toastId,
                "success",
                TIME_RESULT,
                "Variação editada com sucesso"
            )
        }
    }


    return {
        isError: isError,
        block: block,
    }
}